import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ActiveItemDetails from "components/active-item/ActiveItemDetails";
import ActiveItemProperties from "components/active-item/ActiveItemProperties";
import ReceivedOfferFail from "./ReceivedOfferFail";
import ReceivedOfferStart from "./ReceivedOfferStart";
import ReceivedOfferAccept from "./ReceivedOfferAccept";
import ReceivedOfferDecline from "./ReceivedOfferDecline";
import ReceivedOfferCounter from "./ReceivedOfferCounter";
import ReceivedOfferConfirm from "./ReceivedOfferConfirm";
import ReceivedOfferSuccess from "./ReceivedOfferSuccess";
import { useRefreshItems } from "hooks/useRefreshItems";
import { useSoundPath } from "hooks/useSoundPath";
import ModalWindow from "components/ModalWindow";

const ReceivedOfferPopup = ({ close }) => {

  const {offerData} = useSelector((state) => state.popups)
  const {name, image, properties, owned_by_self, packType, tag, type} = offerData.data;
  const {expiry_in_days, expiry_in_hours, expiry_in_minutes, isCounter} = offerData;
  const refreshItems = useRefreshItems();
  const playSound = useSoundPath();
  const [step, setStep] = useState('start');
  const [popupTitle, setPopupTitle] = useState('You received an offer!');
  const [counterData, setCounterData] = useState({
    amount: null,
    days: null,
    hours: null
  });

  const getTitleByStep = () => {
    switch (step) {
      case 'accept':
        return setPopupTitle('Accept Offer')
      case 'counter':
        return setPopupTitle('Make a Counter Offer')
      case 'decline':
        return setPopupTitle('Decline offer?')
      default:
        return isCounter === true ? setPopupTitle('You received a counter offer!') : setPopupTitle('You received an offer!')
    }
  }


  const nextStep = (step) => {
    playSound('main');
    setStep(step)
  }

  const closeWindow = () => {
    close();
    setStep('start');
  }

  useEffect(() => {
    getTitleByStep();
  }, [step])

  return (
    <ModalWindow close={closeWindow}>
      {
        !step.includes('confirm') && !step.includes('success') && step !== 'fail' ?
          <section className="sell-card" onClick={(e) => e.stopPropagation()}>
            <section className="sell-card__details">
            <ActiveItemDetails
             name={name}
             img={image}
             properties={properties}
             packType={packType}
             tag={tag}
             cost={offerData.offer_amount}
             isMine={owned_by_self}
             type={type}
            />
            <ActiveItemProperties properties={properties} />
            </section>
            <section className="sell-card__info sell-card__info--offer">
              <header className="sell-card__header">
                <h2 className="sell-card__title">{popupTitle}</h2>
                <button className="sell-card__close" onClick={closeWindow}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"></path>
                  </svg>
                </button>
              </header>
              {
                step === 'start' &&
                <ReceivedOfferStart
                  nextStep={nextStep}
                  id={offerData.id}
                  cost={offerData.offer_amount}
                  date={offerData.offer_submitted}
                  isCounter={isCounter}
                  days={expiry_in_days}
                  hours={expiry_in_hours}
                  minutes={expiry_in_minutes}
                />
              }

              {
                step === 'accept' &&
                <ReceivedOfferAccept cost={offerData.offer_amount} nextStep={setStep} />
              }

              {
                step === 'decline' &&
                <ReceivedOfferDecline
                  id={offerData.id}
                  date={offerData.offer_submitted}
                  cost={offerData.offer_amount}
                  setStep={setStep}
                  closeWindow={closeWindow}
                  isCounter={isCounter}
                  refreshItems={refreshItems}
                  playSound={playSound}
                />
              }

              {
                step === 'counter' &&
                <ReceivedOfferCounter
                  id={offerData.id}
                  cost={offerData.offer_amount}
                  nextStep={nextStep}
                  closeWindow={closeWindow}
                  counterData={counterData}
                  setCounterData={setCounterData} />
              }
            </section>
          </section>
          :
          null
      }

      {
        step.includes('confirm') &&
        <ReceivedOfferConfirm
          type={step}
          id={offerData.id}
          setStep={setStep}
          closeWindow={closeWindow}
          counterData={counterData}
          isCounter={isCounter}
          refreshItems={refreshItems}
          playSound={playSound}
        />
      }

      {
        step.includes('success') &&
        <ReceivedOfferSuccess type={step} closeWindow={closeWindow} />
      }

      {
        step === 'fail' && <ReceivedOfferFail closeWindow={closeWindow} />
      }
    </ModalWindow>
  )
}

export default ReceivedOfferPopup
